import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Car, Search, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-[#0a1628] flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        {/* 404 Number */}
        <h1 className="text-[150px] font-bold text-[#ff6b35] leading-none mb-4">
          404
        </h1>
        
        {/* Message */}
        <h2 className="text-3xl font-bold text-white mb-4">
          Page Not Found
        </h2>
        <p className="text-[#a8b8d0] text-lg mb-8">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        
        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="flex items-center justify-center gap-2 bg-[#ff6b35] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#e55a2b] transition-colors"
          >
            <Home size={20} />
            Back to Home
          </Link>
          <Link
            to="/inventory"
            className="flex items-center justify-center gap-2 bg-[#132238] text-white px-6 py-3 rounded-lg font-semibold border border-[#1a4d8c] hover:bg-[#1a2d47] transition-colors"
          >
            <Car size={20} />
            Browse Inventory
          </Link>
        </div>
        
        {/* Go Back Link */}
        <button
          onClick={() => window.history.back()}
          className="mt-6 text-[#a8b8d0] hover:text-white flex items-center justify-center gap-2 mx-auto transition-colors"
        >
          <ArrowLeft size={16} />
          Go back to previous page
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
